import { moduleConfigCreator } from '@infotech/4sides-reports'
import { AsyncComponent } from '@infotech/base-components'

export default moduleConfigCreator({
  RouteComponent: AsyncComponent(() => import(`./RouteComponent`)),
})
